import React, { createContext, useState } from "react";
import { getAllServices } from "../Apis/ServicesApis";
import { getAllPackageServices } from "../Apis/PackageServices";
import apiClient from "../utils/apiClient";

const Context = createContext();

export const ContextProvider = ({ children }) => {
  const [services, setServices] = useState([]);
  const [addOnServices, setAddOnServices] = useState([]);
  const [packageServices, setPackageServices] = useState([])
  const [error, setError] = useState(null);
  const [brands, setBrands] = useState([])
  const [permissions, setPermissions] = useState([])
  const [roles, setRoles] = useState([]);
  const [activeRoles, setActiveRoles] = useState([]);
  const [myPermissions, setMyPermissions] = useState([])
  const [isConfirmDeleteModelOpen, setIsConfirmDeleteModelOpen] = useState(false);
  const [itemIdToDelete, setItemIdToDelete] = useState(null);


  // const token = localStorage.getItem("token");


  const getServices = async () => {
    try {
      const response = await getAllServices()

      if (response?.status === true) {
        setServices(response?.services);
      } else {
        setError("Failed to fetch services");
      }
    } catch (error) {
      console.error("Error fetching services:", error);
      setError("Error fetching services");
    }
  };
  const getAddOnServices = async () => {
    try {
      const response = await apiClient.get("/addonservices/getalladdonservice");

      if (response.data.status === true) {
        setAddOnServices(response.data.addOnServices);
      } else {
        setError("Failed to fetch services");
      }
    } catch (error) {
      console.error("Error fetching services:", error);
      setError("Error fetching services");
    }
  };
  const getBrands = async () => {
    try {
      const response = await apiClient.get("/vehiclebrand/getallbrands");

      if (response?.data?.status === true) {
        setBrands(response?.data?.brands)
      }
      else {
        setError("Failed to fetch ");
      }

    } catch (error) {
      setError(error?.response?.data?.message || " Error fetching brands");
    }
  }

  const getPackageServices = async () => {
    try {
      const response = await getAllPackageServices()

      if (response?.status === true) {
        setPackageServices(response?.allPackages);
      } else {
        setError("Failed to fetch services");
      }
    } catch (error) {
      console.error("Error fetching services:", error);
      setError("Error fetching services");
    }
  };

  const getAllRoles = async () => {

    try {
      const response = await apiClient.get(`/role/allroles`);
      if (response?.data?.status === true) {
        const arArr = response?.data?.data.filter(obj => obj.isActive);
        setRoles(response?.data?.data);
        setActiveRoles(arArr);
      }
    } catch (error) {
      setError(error?.response?.data?.message || 'Error for geting roles')
    }

  }

  const getPermissions = async () => {
    try {
      const response = await apiClient.get(`/permission/getallpermission`);
      if (response?.data.status === true) {
        setPermissions(response?.data?.data);
      }
    } catch (error) {
      setError(error?.response?.data?.message || "Error fetching permissions");
    }
  };

  const getMyPermissions = async () => {
    try {
      const response = await apiClient.get(`/employee/permission`);
      if (response?.data?.status === true) {
        setMyPermissions(response?.data?.data);
      }
    } catch (error) {
      setError(error?.response?.data?.message || "Error fetching permissions");
    }
  };

  const confirmDelete = (Id) => {
    setItemIdToDelete(Id)
    setIsConfirmDeleteModelOpen(true)
  }


  const contextvalue = {
    services, setServices, error, setError, getServices, getAddOnServices, addOnServices, brands, setBrands, getBrands, getPackageServices, packageServices, setPackageServices, permissions, getPermissions, roles,
    activeRoles, getAllRoles, myPermissions, getMyPermissions, isConfirmDeleteModelOpen, setIsConfirmDeleteModelOpen, itemIdToDelete, setItemIdToDelete, confirmDelete
  };

  return (
    <Context.Provider value={contextvalue}>
      {children}
    </Context.Provider>
  );
};

export default Context; 
